import { TranslatePipe } from "@ngx-translate/core";
import { Apollo } from "apollo-angular";
import * as Highcharts from "highcharts";
import { Options } from "highcharts";
import { HighchartsChartModule } from "highcharts-angular";
import HC_more from "highcharts/highcharts-more";

import { isPlatformBrowser } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
  computed,
  inject,
} from "@angular/core";

import { SearchFilter } from "../../../apis/networkdashboard/graphql/graphql";
import { AIRT_SCAN_CLASSIFICATION_PROTOCOL_QUERY } from "../../../apis/networkdashboard/static/graphql-queries/airtscan";
import { chartStats } from "../../../helpers/airt/airt";
import { extendHighcharts } from "../../../helpers/highcharts";
import { CertChartOptions } from "./cert-chart-options";

HC_more(Highcharts);

@Component({
  selector: "cert-chart",
  templateUrl: "cert-chart.html",
  styleUrls: ["cert-chart.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HighchartsChartModule, TranslatePipe],
})
export class CertChartComponent implements OnChanges {
  private platformId = inject(PLATFORM_ID);
  private apollo = inject(Apollo);

  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  @Input() searchFilter: SearchFilter;
  public chartRef: any;

  highcharts: typeof Highcharts = Highcharts;
  // @ts-expect-error Faulty typing
  chartOptions: Options = CertChartOptions;
  public classifications: any[] = [];
  protected isBrowser = computed(() => isPlatformBrowser(this.platformId));
  private loading = true;
  private deferLoading = false;
  private filterUpdated = false;
  private transportGrouped: any[] = [];
  private classifications_unsorted: any[] = [];

  constructor() {
    if (this.isBrowser()) {
      extendHighcharts(this.highcharts);
    }
  }

  get noDataFound(): boolean {
    return !this.filterUpdated && !this.loading && this.transportGrouped.length === 0;
  }

  get haveChart(): boolean {
    return this.chartRef && "angular" in this.chartRef;
  }

  toggleLoading(state: boolean) {
    this.loading = state;
    if (!this.haveChart) {
      return;
    }

    if (state) {
      this.chartRef.showLoading(" ");
    } else {
      this.chartRef.hideLoading(" ");
    }
  }

  setChartInstance(chart: Highcharts.Chart) {
    this.chartRef = chart;
    this.toggleLoading(true);
    if (this.deferLoading) {
      console.log("Deferred loading start");
      this.deferLoading = false;
      this.fetchBubbleChartData();
    }

    // this.chartRef.hideNoData();
  }

  async fetchBubbleChartData() {
    this.toggleLoading(true);
    this.apollo
      .query<any>({
        query: AIRT_SCAN_CLASSIFICATION_PROTOCOL_QUERY,
        // fetchPolicy: "network-only",
        variables: {
          filter: this.searchFilter,
        },
      })
      .subscribe(({ data }) => {
        const transformedStats = chartStats(data.airtScans.edges || []);
        this.transportGrouped = transformedStats.transports;
        this.classifications_unsorted = transformedStats.classifications;
        this.classifications = this.classifications_unsorted.sort((x, y) =>
          x.order > y.order ? 1
          : x.order < y.order ? -1
          : 0,
        );
        this.setSeries();
        this.toggleLoading(false);
        this.filterUpdated = false;
      });
  }

  clearSeries() {
    if (!this.chartRef || !this.chartRef.series) {
      return;
    }

    while (this.chartRef.series.length > 0) {
      this.chartRef.series[0].remove(false);
    }
    this.chartRef.redraw(); // update the visual aspect
  }

  setSeries() {
    this.clearSeries();

    this.transportGrouped.forEach((data, index) => {
      if (!this.chartRef.series || this.chartRef.series[index] === undefined) {
        this.chartRef.addSeries(
          {
            name: "",
            data: [data],
          },
          false,
          false,
        );
      } else {
        this.chartRef.series[index].update({ name: "" }, false);
        this.chartRef.series[index].setData([data], false, false, false);
      }
    });
    this.chartRef.redraw(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchFilter && "beforeSourceDate" in this.searchFilter) {
      this.filterUpdated = true;
      if (!this.haveChart) {
        console.log("Defer loading of chartData until chartRef appears");
        this.deferLoading = true;
        return;
      }

      this.fetchBubbleChartData();
    }
  }
}
